export const getFinderUrl = (network: string, txHash: string) => `https://terrasco.pe/${network}/tx/${txHash}`;
